import { render, staticRenderFns } from "./organisationList.vue?vue&type=template&id=2904aa37"
import script from "./organisationList.vue?vue&type=script&lang=js"
export * from "./organisationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports